import { toggleMobileMenu } from "~/utils/menu";
import { forwardRef, useImperativeHandle, useRef } from "react";

const MobileMenuToggle = forwardRef<HTMLElement, object>((_, ref) => {
    const elRef = useRef<HTMLElement | null>(null);

    // Expose the internal ref to the parent component
    useImperativeHandle(ref, () => elRef.current as HTMLElement, []);

    const toggleMobile = () => {
        if (elRef.current) {
            toggleMobileMenu(elRef as React.RefObject<HTMLElement>)
        }
    };

    return (
        <>
            <i onClick={toggleMobile} ref={elRef} className="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </>
    );
});

MobileMenuToggle.displayName = "MobileMenuToggle";

export default MobileMenuToggle;